export const fabPalette = {
	primary: {
		main: "#2E7D32",
		light: "#4CAF50",
		dark: "#1B5E20",
		contrastText: "#ffffff",
	},
	secondary: {
		main: "#C62828",
		light: "#EF5350",
		dark: "#B71C1C",
		contrastText: "#ffffff",
	},

	status: {
		warning: "#CC0000",
		info: "#b2e5ed",
		infoText: "#000",
		success: "#4CAF50",
		error: "#f44336",
	},

	shifts: {
		day: "#DDD116",
		dayBorder: "rgb(224, 208, 101)",
		night: "#A142DD",
		nightBorder: "rgb(183, 102, 233)",
	},

	crews: {
		A: "#B2E08A",
		B: "#E83011",
		C: "#3878B4",
		D: "#F3A506",
	},

	background: {
		paper: "#ffffff",
		default: "#f5f5f5",
		elevated: "#fafafa",
	},

	text: {
		primary: "#212121",
		secondary: "#757575",
		disabled: "#9e9e9e",
		light: "#ffffff",
		lightMuted: "rgb(236, 236, 236)",
	},

	grey: {
		50: "#fafafa",
		100: "#f5f5f5",
		200: "#eeeeee",
		300: "#e0e0e0",
		400: "#bdbdbd",
		500: "#9e9e9e",
		divider: "#e2e8f0",
	},

	map: {
		assetHeader: "#0D47A1",
		parentChildHeader: "#546E7A",
		leafChildHeader: "#90A4AE",
	},

	shadows: {
		sm: "0 2px 8px rgba(0, 0, 0, 0.08)",
		md: "0 4px 16px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)",
		lg: "0 6px 24px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.08)",
	},

	action: {
		hover: "#f1f5f9",
	},

	common: {
		white: "#ffffff",
		black: "#000000",
	},
} as const;

export const hexToRgba = (hex: string, opacity: number): string => {
	const r = Number.parseInt(hex.slice(1, 3), 16);
	const g = Number.parseInt(hex.slice(3, 5), 16);
	const b = Number.parseInt(hex.slice(5, 7), 16);
	return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export type FabPalette = typeof fabPalette;
